import { RouteComponentProps } from 'react-router-dom';
import { parse } from '@tock/query-string';

import { IWithContextProps, withContext } from '@tock/coretypes';
import BaseComponent from '@tock/shared/components/BaseComponent';
import connect, { DefaultConnectProps } from '@tock/shared/utils/connect';

class EmailChangeRoute extends BaseComponent<
  DefaultConnectProps & RouteComponentProps & IWithContextProps
> {
  componentDidMount() {
    const {
      actions,
      location: { search },
    } = this.props;
    const query = parse(search);

    if (!query.token) {
      actions.toast.showError('Your email change confirmation link is invalid.');
      this.props.history.push('/');
    }

    actions.app
      .loginWithUpdateEmailToken(query.token)
      .then(() => {
        actions.app.confirmChangeEmail(query.token);
      })
      .then(actions.app.fetchPatronProfile)
      .then(this.handleSuccess)
      .catch(this.handleFailure);
  }

  handleFailure() {
    this.props.actions.toast.showError('We were unable to confirm your change of email.');
    this.props.history.push(`/profile/account`);
  }

  handleSuccess() {
    this.props.history.push(`/profile/account`);
  }

  render() {
    return null;
  }
}

export default connect<RouteComponentProps>(withContext(EmailChangeRoute));
